module.exports = __webpack_public_path__ + "static/img/LinkedIn.5593f1ee.png";